const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoMacro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    style: {
      fill: "#232b54"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,7.4c-1.89,0-3.45,1.46-3.56,3.32,0,.05.01.09.05.13.03.04.08.05.13.05h1.26c.09,0,.16-.07.17-.16.1-1,.94-1.76,1.96-1.76s1.86.76,1.96,1.76c0,.09.08.16.17.16h1.25s.1-.02.13-.05.05-.08.05-.13c-.11-1.87-1.68-3.32-3.56-3.32",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.33c-.89,0-1.62.72-1.62,1.6s.73,1.6,1.62,1.6,1.62-.72,1.62-1.6-.73-1.6-1.62-1.6",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,5.47c-1.43,0-2.79.54-3.82,1.53-1.03.98-1.62,2.3-1.68,3.72,0,.05.02.09.05.13.04.04.08.05.13.05h1.25c.09,0,.17-.07.17-.16.1-2.07,1.81-3.69,3.91-3.69s3.81,1.62,3.91,3.69c0,.09.08.16.17.16h1.25s.09-.02.13-.05.05-.08.05-.13c-.05-1.41-.65-2.73-1.68-3.72-1.03-.98-2.39-1.53-3.82-1.53",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoMacro);
export default __webpack_public_path__ + "static/media/banco-macro.ddd54d81360c6cab1bfbe9ca784fa009.svg";
export { ForwardRef as ReactComponent };